module.exports = __webpack_public_path__ + "socicon.9a64ef938f9e55a70a4d.ttf";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/socicon/socicon.ttf
// module id = ../../../../../src/assets/vendors/base/fonts/socicon/socicon.ttf
// module chunks = styles